import { FDealType, FOfferType, isAvailable } from 'shared/common/packages/JsonQuery';

import { PriceContainer } from '../../containers/filters/PriceContainer';
import { IFilter } from '../../types/filters';

export const price: IFilter = {
  availability: isAvailable(FDealType.Any, FOfferType.Any),
  component: PriceContainer,
};
